import React from 'react';
import { Plus } from 'lucide-react';

const CategoryTabs = ({ 
  categories = [], 
  activeCategory, 
  onCategoryChange,
  onEditClick,
  showEditButton = true,
  formatLabel,
  className = ''
}) => {
  // Handle both array of strings and array of objects
  const normalizedCategories = categories.map(cat => 
    typeof cat === 'string' ? { id: cat, label: cat } : cat
  );

  return (
    <div className={`flex gap-2 items-center ${className}`}>
      {/* All Tab */}
      <button
        onClick={() => onCategoryChange('all')}
        data-testid="category-tab-all"
        className={`px-3 py-1.5 rounded-lg text-xs font-medium transition-all whitespace-nowrap border ${
          activeCategory === 'all'
            ? 'bg-white text-black border-white'
            : 'bg-black text-white border-gray-400 hover:bg-gray-900'
        }`}
      >
        All
      </button>
      
      {/* Dynamic Category Tabs */}
      {normalizedCategories.map((category) => {
        const catId = category.id || category;
        const catLabel = formatLabel ? formatLabel(catId) : (category.label || catId);
        
        return (
          <button
            key={catId}
            onClick={() => onCategoryChange(catId)}
            data-testid={`category-${catId}-btn`}
            className={`px-3 py-1.5 rounded-lg text-xs font-medium transition-all whitespace-nowrap border ${
              activeCategory === catId
                ? 'bg-white text-black border-white'
                : 'bg-black text-white border-gray-400 hover:bg-gray-900'
            }`}
          >
            {catLabel}
          </button>
        );
      })}
      
      {/* Add/Edit Categories Button */}
      {showEditButton && onEditClick && (
        <button
          onClick={onEditClick}
          data-testid="edit-categories-btn"
          className="px-2 py-1.5 rounded-lg text-xs font-medium transition-all whitespace-nowrap bg-black text-white hover:bg-gray-900 border border-dashed border-gray-400"
          title="Add Category"
        >
          <Plus size={12} className="inline" />
        </button>
      )}
    </div>
  );
};

export default CategoryTabs;
